import api from './client';

export const getAdminUsers = async () => {
  const { data } = await api.get('/admin/users');
  return data;
};

export const createAdminUser = async (userData) => {
  const { data } = await api.post('/admin/users', userData);
  return data;
};

export const updateUserRole = async (userId, role) => {
  const { data } = await api.put(`/admin/users/${userId}/role`, { role });
  return data;
};

export const updateUserStatus = async (userId, isActive) => {
  const { data } = await api.put(`/admin/users/${userId}/status`, { is_active: isActive });
  return data;
};

export const updateUserDetails = async (userId, updates) => {
  const { data } = await api.put(`/admin/users/${userId}`, updates);
  return data;
};

export const deleteUser = async (userId) => {
  const { data } = await api.delete(`/admin/users/${userId}`);
  return data;
};
